const scrollHandler = () => {
    var header = document.querySelectorAll(".header_home")[0];
    var usermenu = document.querySelector(".usermenu")
    var scroll = window.scrollY;
    if(header) {
        if (scroll >= 100) {
            header.classList.add("header_sticky");
            if(usermenu){
                usermenu.style.display = 'none'
            }
        } else {
            header.classList.remove("header_sticky");
            if(usermenu){
                usermenu.style.display = 'block'
            }
        }
    }
}

const goToByScroll = id => {
    var element = document.getElementById(`${id}`);
    element.scrollIntoView({
        block: 'start',
        behavior: 'smooth'
    })
}

module.exports = {
    scrollHandler,
    goToByScroll
}


// WEBPACK FOOTER //
// ./web/util/animation.js